import { render } from "./ContentColumn.vue?vue&type=template&id=6ef11e75"
import script from "./ContentColumn.vue?vue&type=script&lang=js"
export * from "./ContentColumn.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__